import { useEffect } from "react";

interface TitleUpdaterProps {
  title: string;
}

const TitleUpdater: React.FC<TitleUpdaterProps> = ({ title }) => {
  useEffect(() => {
    document.title = title;
  }, [title]);

  return null;
};

export default TitleUpdater;
